import { createClient } from "@supabase/supabase-js";

declare global {
  interface Window {
    __PORTFOLIO_CONFIG__?: { supabaseUrl?: string; supabasePublishableKey?: string; apiUrl?: string };
  }
}

// Supplied by /runtime-config.js. It intentionally contains only public values.
const config = window.__PORTFOLIO_CONFIG__;
const url = config?.supabaseUrl;
const anonKey = config?.supabasePublishableKey;

export const supabase = url && anonKey ? createClient(url, anonKey, { auth: { persistSession: true, autoRefreshToken: true } }) : null;
